var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardSelected(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 30,
    viewBox: "0 0 32 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9424 29.25V0.75M15.9424 11.8333H30.5674M5.21738 0.75H26.6674C27.7017 0.75 28.6937 1.15036 29.4251 1.86299C30.1565 2.57563 30.5674 3.54218 30.5674 4.55V25.45C30.5674 26.4578 30.1565 27.4244 29.4251 28.137C28.6937 28.8496 27.7017 29.25 26.6674 29.25H5.21738C4.18304 29.25 3.19106 28.8496 2.45967 28.137C1.72827 27.4244 1.31738 26.4578 1.31738 25.45V4.55C1.31738 4.05098 1.41826 3.55684 1.61425 3.0958C1.81025 2.63477 2.09752 2.21586 2.45967 1.86299C3.19106 1.15036 4.18304 0.75 5.21738 0.75Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardSelected);
export default __webpack_public_path__ + "static/media/dashboard-selected.808bf5443429402c7739efd3e61ca19e.svg";
export { ForwardRef as ReactComponent };